import { classNames, useEffect, useState } from 'libs/react';
import { React } from 'libs/react';
import { DealItemPickerPackageList } from './DealItemPickerPackageList';
import { FormSection } from 'components/form/FormSection';
import { Button } from 'components/Button';
import { useDealItemPicker } from './DealItemPicker';
import './DealItemPickerPackagePane.scss';
/**
 * @component DealItemPickerPackages
 * @since 1.0.0
 */
export function DealItemPickerPackagePane(props) {
    const { style } = Object.assign({ style: 'normal' }, props);
    const { item } = useDealItemPicker();
    const [cardDisplay, setCardDisplay] = useState(true);
    const onPressList = () => {
        setCardDisplay(false);
    };
    const onPressCard = () => {
        setCardDisplay(true);
    };
    useEffect(() => {
        if ((item === null || item === void 0 ? void 0 : item.packages) && item.packages.length > 6) {
            setCardDisplay(false);
        }
    }, [item === null || item === void 0 ? void 0 : item.packages.length]);
    const className = classNames('deal-item-picker-package-pane', 'deal-item-picker-package-pane--' + style, props.className);
    return (React.createElement("div", { className: className },
        React.createElement(FormSection, { title: t('Packages'), button: React.createElement("div", { className: "deal-item-picker-package-pane-button-container" },
                React.createElement(Button, { picto: "list", onPress: onPressList, className: `button-list ${!cardDisplay && 'active'}` }),
                React.createElement(Button, { picto: "fas cards-blank", onPress: onPressCard, className: `button-card ${cardDisplay && 'active'}` })) },
            React.createElement(DealItemPickerPackageList, { cardDisplay: cardDisplay }))));
}
